import React, { Component } from 'react';
import { CartesianGrid, Legend, Line, LineChart, Tooltip, XAxis, YAxis } from 'recharts';
import { connect } from 'react-redux';
import { chartState, chartDispatcher } from '../../../../store';
import { PropTypes } from 'prop-types';
import { DiagramTooltip } from '.';

export class DiagramComponent extends Component {
  constructor() {
    super();

    this.state = {
      height: null,
      width: null
    };
  }

  componentDidMount() {
    window.addEventListener( 'resize', this.onResize );
    this.setRatio();

    const { chart, chartName } = this.props;

    if( chartName && !chart[chartName] ) {
      this.props.getChart( chartName ).then( this.setRatio );
    }
  }

  componentDidUpdate( prevProps ) {
    const { chart, chartName } = this.props;

    if( chartName !== prevProps.chartName && !chart[chartName] ) {
      this.props.getChart( chartName ).then( this.setRatio );
    }
  }

  componentWillUnmount() {
    window.removeEventListener( 'resize', this.onResize );
  }

  setRatio = () => {
    const { chart, chartName } = this.props;
    const data = chart[chartName];
    this.ratio = data && data.width / data.height;
    this.setNewSize();
  }

  getTicks( axis ) {
    const ticks = [];
    for( let tick = axis.min || 0; tick <= axis.max; tick += axis.step ) {
      ticks.push( tick );
    }
    return ticks;
  }

  onResize = () => {
    this.timeout && clearTimeout( this.timeout );
    this.timeout = setTimeout( this.setNewSize, 10 );
  }

  setNewSize = () => {
    const { parentPanel } = this.props;
    const { height, width } = this.state;

    if( parentPanel ) {
      this.setState( { width: parentPanel.clientWidth * 0.7 || width, height: parentPanel.clientWidth * 0.7 / this.ratio || height } );
    }
  }

  render() {
    const { chart, chartName } = this.props;
    const { height, width } = this.state;
    if( !chart[chartName] ) {
      return null;
    }

    const data = chart[chartName];
    const lines = data.lines.map( line => 
      <Line key={ line.name } name={ line.name } type="monotone" dataKey={ line.name } stroke={ line.color } activeDot={ { r: 5 } }/> 
    );

    return <div className="diagram">
      <h4>{ chartName }</h4>
      <LineChart 
        width={ Math.min( data.width, width ) } 
        height={ Math.min( data.height, height ) } 
        data={ data.points } 
        margin={ { top: 20, right: 20, left: 20, bottom: 20 } }
      >
        <CartesianGrid/>
        <XAxis 
          type="number" 
          domain={ [data.xAxis.min || 0, data.xAxis.max] } 
          ticks={ this.getTicks( data.xAxis ) } 
          height={ 75 } 
          dataKey={ data.dataKey } 
          label={ data.xAxis.label }
        />
        <YAxis 
          type="number" 
          domain={ [data.yAxis.min || 0, data.yAxis.max] } 
          ticks={ this.getTicks( data.yAxis ) } 
          label={ { value: data.yAxis.label, angle: -90 } } 
          width={ 100 }
        />
        <Tooltip content={ <DiagramTooltip dataKey={ data.dataKey } units={ data.units }/> }/>
        { lines }
        <Legend />
      </LineChart>
    </div>;
  }
}

DiagramComponent.propTypes = {
  chart: PropTypes.shape( {} ),
  chartName: PropTypes.string.isRequired,
  parentPanel: PropTypes.shape( {} )
};

export const Diagram = connect( chartState, chartDispatcher )( DiagramComponent );